<template>

<div>
  <b-container fluid>
    <b-row class="modal-block text-center">
      <b-col>
        <h6 class="column-title">Proyecto</h6>
        {{workOrder.projectCodeId}} - {{workOrder.projectTitle}}
      </b-col>
      <b-col>
        <h6 class="column-title">Cliente</h6>
        {{workOrder.clientName}}
      </b-col>
      <b-col>
        <h6 class="column-title">Operario</h6>
        {{workOrder.employeeName}}
      </b-col>
    </b-row>

    <b-container fluid class="cambiarProyectoContent" v-if="permisoCambiarProyecto">
      <span @click="cambiarMostrarSelectProyecto()" class="cambiarProyecto">
        Cambiar proyecto
      </span>
<!--      <model-select v-if="mostrarSelectProyecto" v-model="workOrder.newProject" :model-request="loadProjects" label="" placeholder="Buscar por código" :get-option-label="project => project.codeId + ' - ' + project.title" />-->
      <model-select v-if="mostrarSelectProyecto" v-model="nuevoProyecto" :model-request="loadProjects" label="" placeholder="Buscar por código" :get-option-label="project => project.codeId + ' - ' + project.title" />
      <span v-if="mostrarSelectProyecto" class="cambiarProyectoExplicacion">
        *Solo podrá ver aquellos partes de trabajo de proyectos que usted tenga asignados, si cambia el proyecto de un parte por otro que no tenga asignadao ya no podrá verlo.
      </span>
      <div class="cambiarProyectoBotonContent">
        <b-button v-if="mostrarSelectProyecto" @click="cambiarProyecto()" variant="primary">Cambiar</b-button>
      </div>
    </b-container>

    <div class="modal-block">
      <b-row>
        <b-col>
          <icon-input :disabled="disabled" v-model="workOrder.workOrderDate" label="Fecha" type="date" icon="calendar-alt" @input="$emit('onDateModified')"/>
        </b-col>
        <b-col>
          <div class="form-group">
            <label>Dieta
              <b-form-select :disabled="disabled" v-model="workOrder.mealCostType" :options="mealCostOptions"/>
            </label>
          </div>
        </b-col>
        <b-col class="d-flex">
          <div v-if="admWorkOrder" class="form-group align-self-end">
            <b-form-checkbox :disabled="disabled" v-model="workOrder.travel">Desplazamiento</b-form-checkbox>
          </div>
          <div v-else class="form-group">
            <icon-input :disabled="disabled" v-model.number="workOrder.travelKm" type="number"
                        label="Desplazamiento" icon="car" >
              <div slot="after-input" class="align-self-end pl-1">Km</div>
            </icon-input>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <icon-input :disabled="disabled" v-model.number="workOrder.ordinaryHours" type="number"
                      label="Horas Ordinarias" :icon="['far', 'clock']"/>
        </b-col>
        <b-col>
          <icon-input :disabled="disabled" v-model.number="workOrder.overtimeHours" type="number"
                      label="Horas Extra" :icon="['far', 'clock']"/>
        </b-col>
        <b-col>
          <icon-input v-if="admWorkOrder" :disabled="disabled" v-model.number="workOrder.holidayHours" type="number"
                      label="Horas Festivas" :icon="['far', 'clock']"/>
          <icon-input v-if="!admWorkOrder" :disabled="disabled" v-model.number="workOrder.pauseHours" type="number"
                      label="Horas Pausa" :icon="['far', 'clock']"/>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="d-flex">
          <div class="form-group align-self-end">
            <b-form-checkbox :disabled="disabled" v-model="workOrder.shiftWork">Turnicidad</b-form-checkbox>
          </div>
        </b-col>
        <b-col class="d-flex">
          <div class="form-group align-self-end">
            <b-form-checkbox :disabled="disabled" v-model="workOrder.nightShift">Nocturnidad</b-form-checkbox>
          </div>
        </b-col>
        <b-col class="d-flex">
          <div class="form-group align-self-end">
            <b-form-checkbox :disabled="disabled" v-model="workOrder.preventiveResource">Recurso Preventivo</b-form-checkbox>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="d-flex">
          <div class="form-group align-self-end">
            <b-form-checkbox :disabled="disabled" v-model="workOrder.onCallDuty">Guardia</b-form-checkbox>
          </div>
        </b-col>
        <b-col class="d-flex" v-if="!admWorkOrder">
          <div class="form-group align-self-end">
            <b-form-checkbox :disabled="disabled" v-model="workOrder.saturday">Sábado</b-form-checkbox>
          </div>
        </b-col>
        <b-col class="d-flex" v-if="!admWorkOrder">
          <div class="form-group align-self-end">
            <b-form-checkbox :disabled="disabled" v-model="workOrder.holiday">Domingo/Festivo</b-form-checkbox>
          </div>
        </b-col>
      </b-row>
      <b-row v-if="!admWorkOrder">
        <b-col>
          <span class="d-block">Inicio trabajos
          </span>
          <datetime :disabled="disabled" type="datetime" v-model="workOrder.initTime" format="dd/MM/yyyy HH:mm" input-class="form-control" zone="UTC"></datetime>
        </b-col>
        <b-col>
          <span class="d-block">Fin trabajos
          </span>
          <datetime :disabled="disabled" type="datetime" v-model="workOrder.endTime" format="dd/MM/yyyy HH:mm" input-class="form-control" zone="UTC"></datetime>
        </b-col>
        <b-col>
          <label class="d-block">Horas de pausa
            <input :disabled="disabled" v-model="workOrder.pauseHoursText" type="text" class="form-control"/>
          </label>
        </b-col>
      </b-row>
    </div>

    <b-row>
      <b-col>
        <div class="form-group">
          <label class="d-block">Observaciones del Operario
            <textarea :disabled="disabled" v-model="workOrder.comments" cols="30" rows="3" class="form-control"/>
          </label>
        </div>
      </b-col>
    </b-row>
  </b-container>

  <b-container fluid v-if="admWorkOrder">
    <b-row class="modal-block">
      <b-col>
        <label class="d-block">Listado de materiales
          <textarea :disabled="disabled" v-model="workOrder.materials" cols="30" rows="3" class="form-control"/>
        </label>
      </b-col>
      <b-col>
        <label class="d-block">Otros Empleados
          <textarea :disabled="disabled" v-model="workOrder.otherEmployees" cols="30" rows="3" class="form-control"/>
        </label>
      </b-col>
    </b-row>

    <p class="modal-block-title">Cliente</p>
    <b-row>
      <b-col>
        <icon-input :disabled="disabled" v-model="workOrder.clientValidatorName" label="Nombre" icon="user"/>
      </b-col>
      <b-col>
        <icon-input :disabled="disabled" v-model="workOrder.clientValidatorDNI" label="DNI" icon="id-card"/>
      </b-col>
      <b-col>
        <icon-input :disabled="disabled" v-model="workOrder.clientValidatorEmail" label="Email" icon="at"/>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <label class="d-block">Observaciones
          <textarea :disabled="disabled" v-model="workOrder.clientValidatorComments" cols="30" rows="3" class="form-control"/>
        </label>
      </b-col>
    </b-row>
  </b-container>
</div>

</template>

<script>

import IconInput from '@/components/common/IconInput'
import api from '@/api/api'
import ModelSelect from '@/components/common/ModelSelect'
import { Datetime } from 'vue-datetime'
import {session} from '@/auth'

export default {
  name: 'WorkOrderForm',
  components: {IconInput, ModelSelect, Datetime},
  model: {prop: 'workOrder'},
  props: {
    workOrder: {type: Object, required: true},
    disabled: {type: Boolean, default: false}
  },
  data() {
    return {
      mealCostOptions: [
        {value: 'FULL', text: 'Completa'},
        {value: 'HALF', text: 'Media'},
        {value: 'NONE', text: 'Ninguna'}
      ],
      nuevoProyecto: null,
      mostrarSelectProyecto: false
    }
  },
  methods: {
    loadProjects(codeId = null) {
      return api.project.index({codeId, size: 10000, sort: 'codeId'}).then(paginator => paginator.content)
    },
    cambiarMostrarSelectProyecto() {
      this.mostrarSelectProyecto = !this.mostrarSelectProyecto
      this.nuevoProyecto = null
    },
    cambiarProyecto() {
      var hayNuevoProyecto = (this.nuevoProyecto != null) && (this.nuevoProyecto.codeId != null)
      if (hayNuevoProyecto) {
        var changeProjectParams = {
          idProject: this.nuevoProyecto.id,
          idWorkOrder: this.workOrder.id
        }
        api.workOrder.changeProject(changeProjectParams).then(() => {
          this.$toastr('success', 'Cambiado proyecto del parte correctamente')
        })
        this.cambiarMostrarSelectProyecto()

        setTimeout(() => { this.$emit('cambioProyecto') }, 1000)
      }
    }
  },
  computed: {
    admWorkOrder() {
      return this.workOrder.workOrderType === 'ADM'
    },
    permisoCambiarProyecto() {
      if ((session.authorities != null) && session.authorities.includes('ROLE_WORK_ORDER_CHANGE_PROJECT')) {
        return true
      } else {
        return false
      }
    }
  }
}

</script>

<style lang="scss" scoped>

.column-title {
  margin-bottom: 0px;
  font-weight: bold;
}

.cambiarProyectoContent {
  margin-bottom: 20px;
  .cambiarProyecto {
    color: #007bff;
    cursor: pointer;
  }
  .cambiarProyectoExplicacion {
    font-size: 12px;
  }
  .cambiarProyectoBotonContent {
    margin-top: 10px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/workOrder/partials/WorkOrderForm.vue